import { render, staticRenderFns } from "./MergeHeader.vue?vue&type=template&id=d01490a0"
import script from "./MergeHeader.ts?vue&type=script&lang=ts&external"
export * from "./MergeHeader.ts?vue&type=script&lang=ts&external"
import style0 from "./MergeHeader.vue?vue&type=style&index=0&id=d01490a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports